module.exports = __webpack_public_path__ + "media/images/lesson_7/sebastiao_oculos_mergulho-de8bd6b8b3b81b56af18ccfba805b686.png";